import dayjs from 'dayjs';
import {apiRequest} from '../api/async';

const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';

export const formatDateForGridExport = (widgetDate) => {
  const date = dayjs(widgetDate);

  return date.startOf('day').format(dateTimeFormat);
}

export const saveEditDataToApi = async (fullOperation, paramsData , SUCCESS_CODE= '000') => {
  const request = await apiRequest({
    operation: fullOperation,
    data: {
      Params: paramsData,
    },
  });

  if (request.data.ResponseCode === SUCCESS_CODE) {
    return request.data.Response;
  } else {
    throw new Error(request.data.ResponseText);
  }
}

export const toNumberArray = (value) => {
  if (Array.isArray(value)) {
    return value
      .map(Number)
      .filter(Number.isFinite);
  }

  if (value == null || value === '') return [];

  return String(value)
    .split(',')
    .map((v) => Number(v.trim()))
    .filter(Number.isFinite);
};

export const toCommaSeparatedString = (value) => {
  const normalized = toNumberArray(value);
  return normalized.length ? normalized.join(',') : '';
};